import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import NewReportsListContainer from './NewReportsListContainer';
import {indexReports, emptyNewReports, deleteReport} from '../Module';
import Types from 'routes/General/Types';
import {Modal} from "antd";
import ListContainer from "../../Shift/Definition/List/ListContainer";

@connect((state) => ({
  newReports: state.Attendance.Reports.newReports,
  meta: state.Attendance.Reports.metaNewReports,
}), {
  indexReports,
  emptyNewReports,
  deleteReport,
})
@autobind
/**
 *
 * @class ReportsListContainerWrapper
 * @extends PureComponent
 */
export default class NewReportsListContainerWrapper extends React.PureComponent {
  static propTypes = {
    indexReports: PropTypes.func,
    emptyNewReports: PropTypes.func,
    newReports: PropTypes.arrayOf(PropTypes.object),
    meta: PropTypes.object,
    activeItem: PropTypes.number,
    onClick: PropTypes.func,
    onCreateForm: PropTypes.func,
    onTakeReport: PropTypes.func,
    updateData: PropTypes.bool,
    onDeleteHandle: PropTypes.func,
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this._modules = Types._findModule('Report');
    this.state = {
      loading: true,
    };
  }

  /**
   *
   */
  componentDidMount() {
    this._reload();
  }


  _reload(page = 0, limit = app.config.pagination.limit) {
    const {indexReports, emptyNewReports} = this.props;
    if (this._modules && this._modules.id) {
      this.setState({loading: true});
      emptyNewReports();
      indexReports({
        includes: ['type'],
        filterGroups: [
          {
            filters: [
              {
                key: 'module_id',
                value: this._modules && this._modules.id,
                operator: 'eq',
              },
              {
                key: 'visible',
                value: '1',
                operator: 'eq',
              },
            ],
          },
        ],
        page, limit,
      }, () => this.setState({loading: false}));
    }
  }

  /**
   *
   * @param {String} value
   * @private
   */
  _onSearch(value) {
    const {index, meta} = this.props;
    if (this._modules && this._modules.id) {

      this.setState({loading: true}, () => index({
        filterGroups: [
          {
            filters: [
              {
                key: 'module_id',
                value: this._modules && this._modules.id,
                operator: 'eq',
              },
              {
                key: 'visible',
                value: '1',
                operator: 'eq',
              },
            ],
          },
          {
            or: true,
            filters: [
              {
                key: 'label',
                value,
                operator: 'ct',
              },
            ],
          },
        ],
        limit: meta.limit,
      }, () => this.setState({loading: false})));
    }
  }

  /**
   *
   * @return {Object}
   * @private
   */
  _pagination() {
    const {meta} = this.props;

    return {
      total: meta.total,
      pageSize: meta.limit,
      showTotal: (total, range) => app.translate('main.showingFromToOf', {
        start: range[0],
        end: range[1],
        total,
      }),
      onChange: (page, limit) => this._reload(page - 1, limit),
      onShowSizeChange: (page, limit) => this._reload(page - 1, limit),
    };
  }


  /**
   *
   * @return {ListWrapper.props.newReports}
   * @private
   */
  _dataSource() {
    let {newReports} = this.props;
    app._.map(newReports, (report) => {
      report.icon = 'file-chart';
      report.label = report.name;
    });
    return newReports;
  }


  /**
   *
   * @param {Object} item - item to delete
   * @private
   */
  _onDelete(item) {
    const { deleteReport, onDeleteHandle} = this.props;

    Modal.confirm({
      title: app.translate('routes.home.attendance.reports.Delete report'),
      content: app.translate('routes.home.attendance.reports.Are you sure about removing report', { report: item.name }),
      onOk: () => deleteReport(item.id, ()=>{onDeleteHandle()}),
    });
  }

  _onTakeReport = (item)=>{
    const { onTakeReport } = this.props;
    onTakeReport(item);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.updateData !== this.props.updateData && this.props.updateData){
      this._reload();
    }
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {activeItem, meta, onClick, onCreateForm, ...rest} = this.props;
    const {loading} = this.state;

    return (
      <NewReportsListContainer
        items={this._dataSource()}
        loading={loading}
        reload={() => this._reload(meta.currentPage, meta.limit)}
        // onSearch={this._onSearch}
        //   onSearch={}
        pagination={this._pagination()}
        activeItem={activeItem}
        onClick={onClick}
        onCreateForm={onCreateForm}
        onEdit={onClick}
        {...rest}
        onDelete={this._onDelete}
        onTake={this._onTakeReport}
        can={app.can}
      />
    );
  }
}
